import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

// One row per attempt, not per student: a student may sit the same exam many
// times and each sitting gets its own record. `id` is the `studentToIfrsId`
// every other IFRS endpoint keys on (answers, grading, submissions).
export interface IFRSAttemptDTO {
  id: string;
  student: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  marks: number | null;
  isMarked: boolean;
  submittedAt: string | null;
  createdAt: string;
}

export interface IFRSAttemptsMetaDTO {
  total: number;
  page: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IFRSAttemptsData {
  data: IFRSAttemptDTO[];
  meta: IFRSAttemptsMetaDTO;
}

export interface IFRSAttemptsResponse {
  data?: IFRSAttemptsData;
  error?: ApiError;
}

export interface GetIFRSAttemptsParams {
  page: number;
  limit: number;
  examId: string;
}

export const GetIFRSAttempts = async ({
  page,
  limit,
  examId,
}: GetIFRSAttemptsParams): Promise<IFRSAttemptsResponse> => {
  try {
    const response = await axios.get(`/ifrs/${examId}/student/ifrs-exams`, {
      params: { page, limit },
    });
    // Unified envelope: { message, data: { data, meta } }.
    return { data: response.data?.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
